/**
 * WEX Custom Google Maps Functions (v2 Using Database)
 * Code ported from old motorpass theme, needs refactoring, now just ignoring lint.
 * Used for Location Finder
 */

/* eslint-disable */

 var map;
 var markers = [];
 var markerCluster;
 var markerClick = false;
 var infoWindow;
 var markerID;
 var centerPosition = [];

 /* Aux */
 document.addEventListener('DOMContentLoaded', function () {
		jQuery("#selectServiceType").click(function(e, clickedIndex, isSelected, previousValue) {
			var filter_merchant_type = jQuery(this).val();
			console.log('filter_merchant_type : ' + filter_merchant_type);
		});
		jQuery("#selectMerchantBrand").click(function(e, clickedIndex, isSelected, previousValue) {
			var filter_merchant_brand = jQuery(this).val();
			console.log('filter_merchant_brand : ' + filter_merchant_brand);
		});
		jQuery("#reset-opt").click(function() {
			jQuery("#selectServiceType option:selected").removeAttr("selected");
			jQuery("#selectMerchantBrand option:selected").removeAttr("selected");
		});
		jQuery("#see-results-opt").click(function() {
			preInitMap();
		});
 });

 /* Init */
 function preInitMap() {
   if (getUrlParameter('lat') !== '') {
     centerPosition.location_string = decodeURIComponent(getUrlParameter('loc'));
     centerPosition.lat = parseFloat(getUrlParameter('lat'));
     centerPosition.lng = parseFloat(getUrlParameter('lng'));
   } else {
     centerPosition.location_string = 'Melbourne VIC';
     centerPosition.lat = -37.8136;
     centerPosition.lng = 144.9631;
   }
   //debug
   console.log('preInitMap()');
   console.log(centerPosition);
   initMap(centerPosition);
 }

 function initMap(centerPosition) {
   // Set the map center position
   var map_pos_lat = centerPosition.lat;
   var map_pos_lng = centerPosition.lng;

   //debug
   console.log('InitMap()');
   console.log('Default Lat:' + map_pos_lat + ' Lng:' + map_pos_lng);

   var mapOptions = {
     center: { lat: map_pos_lat, lng: map_pos_lng },
     zoom: 15,
     maxZoom: 18,
     minZoom: 7,
     mapTypeId: 'roadmap',
     mapTypeControl: false,
     streetViewControl: false,
     fullscreenControl: false,
     clickableIcons: false,
     styles: [{
       featureType: 'landscape',
       elementType: 'geometry',
       stylers: [{
         saturation: '-100'
       }]
     }, {
       featureType: 'poi',
       elementType: 'labels',
       stylers: [{
         visibility: 'off'
       }]
     }, {
       featureType: 'poi',
       elementType: 'labels.text.stroke',
       stylers: [{
         visibility: 'off'
       }]
     }, {
       featureType: 'poi.attraction',
       elementType: 'labels.icon',
       stylers: [{
         visibility: 'simplified'
       }]
     }, {
       featureType: 'road',
       elementType: 'labels.text',
       stylers: [{
         color: '#545454'
       }]
     }, {
       featureType: 'road',
       elementType: 'labels.text.stroke',
       stylers: [{
         visibility: 'off'
       }]
     }, {
       featureType: 'road.highway',
       elementType: 'geometry.fill',
       stylers: [{
         saturation: '-87'
       }, {
         lightness: '-40'
       }, {
         color: '#ffffff'
       }]
     }, {
       featureType: 'road.highway',
       elementType: 'geometry.stroke',
       stylers: [{
         visibility: 'off'
       }]
     }, {
       featureType: 'road.highway.controlled_access',
       elementType: 'geometry.fill',
       stylers: [{
         color: '#f0f0f0'
       }, {
         saturation: '-22'
       }, {
         lightness: '-16'
       }]
     }, {
       featureType: 'road.highway.controlled_access',
       elementType: 'geometry.stroke',
       stylers: [{
         visibility: 'off'
       }]
     }, {
       featureType: 'road.highway.controlled_access',
       elementType: 'labels.icon',
       stylers: [{
         visibility: 'on'
       }]
     }, {
       featureType: 'road.arterial',
       elementType: 'geometry.stroke',
       stylers: [{
         visibility: 'off'
       }]
     }, {
       featureType: 'road.local',
       elementType: 'geometry.stroke',
       stylers: [{
         visibility: 'off'
       }]
     }, {
       featureType: 'transit',
       elementType: 'all',
       stylers: [{
         visibility: 'simplified'
       }]
     }, {
       featureType: 'transit.station.rail',
       elementType: 'labels.icon',
       stylers: [{
         visibility: 'off'
       }]
     }, {
       featureType: 'water',
       elementType: 'geometry.fill',
       stylers: [{
         saturation: '-52'
       }, {
         hue: '#00e4ff'
       }, {
         lightness: '-16'
       }]
     }]
   };

   map = new google.maps.Map(document.getElementById('map'), mapOptions);

   fetchLocations(map_pos_lat, map_pos_lng, map.getZoom());

   google.maps.event.addListener(map, 'dragend', function () {
     var mapCenter = map.getCenter();
     fetchLocations(mapCenter.lat(), mapCenter.lng(), map.getZoom());
   });

   google.maps.event.addListener(map, 'zoom_changed', function () {
     var mapCenter = map.getCenter();
     fetchLocations(mapCenter.lat(), mapCenter.lng(), map.getZoom());
   });

   jQuery('.action-filter-go').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
     jQuery(this).selectpicker('toggle');
     var mapCenter = map.getCenter();
     fetchLocations(mapCenter.lat(), mapCenter.lng(), map.getZoom());
   });

   // Setup the Autocomplete field
   initAutocomplete();
 }

 async function fetchLocations(map_pos_lat, map_pos_lng, zoom_level) {

   var filter_merchant_type = jQuery('#selectServiceType').val();
   var filter_merchant_brand = jQuery('#selectMerchantBrand').val();

   //debug
   console.log('fetchLocations()');
   console.log('type: ' + filter_merchant_type + ' brand: ' + filter_merchant_brand);

   infoWindow = new google.maps.InfoWindow();
   var radius = {
     19: 1,
     18: 2,
     17: 3,
     16: 4,
     15: 5,
     14: 10,
     13: 18,
     12: 25,
     11: 40,
     10: 100,
     9: 250,
     8: 400,
     7: 800,
     6: 1000,
     5: 1000,
     4: 1000
   };

   try {
     const response = await jQuery.ajax({
       url: '/wp-content/themes/WEX2.0-motorpass/acf-blocks/motorpass-locations-map/get-locations.php',
       dataType: 'xml',
       type: 'post',
       data: {
         lat: map_pos_lat,
         lng: map_pos_lng,
         radius: radius[zoom_level]
       },
       beforeSend: function () {
         jQuery('.loading-wrapper').show();
         jQuery('#listResults').html('');
       }
     });

     if (markerCluster) {
       markerCluster.clearMarkers();
     }

     markers = [];

	 //debug
	 console.log('fetching from: /wp-content/themes/WEX2.0-motorpass/acf-blocks/motorpass-locations-map/get-locations.php');
	 console.log(response);

     jQuery(response).find('Location').each(function (i) {
       var location_xml = jQuery(this);
       var lat = location_xml.find('Latitude').text();
       var lon = location_xml.find('Longitude').text();
       var title = location_xml.find('BusinessName').text();
       var phone = location_xml.find('Phone').text();
       var brand = location_xml.find('MerchantBrand').text();
       var serviceTypes = location_xml.find('ServiceTypes').text();
       var serviceTypesArray = serviceTypes.split(',');

       markerID = `${brand}-${lat}-${lon}`.replace(/[\s.]+/g, '-');

       var location_address = `${location_xml.find('Address1').text()}<br />${location_xml.find('Address2').text()}<br />${location_xml.find('Suburb').text()} ${location_xml.find('Postcode').text()} ${location_xml.find('State').text()}<br />`;
       var plain_address = location_address.replace(/<br\s*\/?>/g, ' ').trim(); // Replace <br /> tags with spaces and trim any extra spaces

       var directions_url = `https://www.google.com/maps/search/?api=1&query=${lat},${lon}`;
       var marker_tags = serviceTypesArray.map(type => `<span class="badge badge-secondary text-capitalize">${type === 'Golden Network' ? 'Diesel Discounts' : type}</span>`).join(' ');

       var latLng = new google.maps.LatLng(lat, lon);

       var listing_markup = `
         <div onclick="highlightMarker('${markerID}');" id="${markerID}" class="location-item">
           <div class="location-content">
             <h4 class="mb-1">${title}</h4>
             <p class="mb-0">${location_address}</p>
             ${phone ? `<p>ph: ${phone}</p>` : ''}
             <a href="${directions_url}" target="_blank" class="directions-link mb-1">Get directions </a>
             ${marker_tags ? `<div class='mt-1'>${marker_tags}</div>` : ''}
             <a data-toggle="modal" data-target="#feedbackModal" class="feedback-link mt-2" data-address="${plain_address}" data-title="${title}">Report a Problem / Feedback</a>
           </div>
         </div>
       `;

       var marker = new google.maps.Marker({
         position: latLng,
         customID: markerID,
         markup: listing_markup,
         tags: serviceTypesArray,
         icon: '/wp-content/themes/WEX2.0-motorpass/acf-blocks/motorpass-locations-map/src/img/map-icon-single.png'
       });

       google.maps.event.addListener(marker, 'click', function () {
         markerID = marker.customID;
         jQuery('.location-item').removeClass('highlight');
         jQuery(`#${markerID}`).addClass('highlight');
         markerClick = true;
         infoWindow.close();
         infoWindow.setContent(listing_markup);
         infoWindow.open(map, marker);
         infoWindow.setPosition(latLng);
       });

       var hide_marker = false;

       if (filter_merchant_type.length > 0) {
         filter_merchant_type.forEach(function (item) {
           if (jQuery.inArray(item, serviceTypesArray) === -1) {
             hide_marker = true;
           }
         });
       }

       if (!hide_marker && filter_merchant_brand.length > 0) {
         if (jQuery.inArray(brand, filter_merchant_brand) === -1) {
           hide_marker = true;
         }
       }

       if (!hide_marker) {
         markers.push(marker);
       }
     });

     const markerClustererOptions = {
       styles: [
         {
           url: '/wp-content/themes/WEX2.0-motorpass/acf-blocks/motorpass-locations-map/src/img/map-icon-cluster.png',
           height: 50,
           width: 50,
           textColor: '#ffffff',
           textSize: 15
         }
       ],
       gridSize: 50
     };

	 markerCluster = new markerClusterer.MarkerClusterer({ markers, map, markerClustererOptions });

     updateList();
     jQuery('.loading-wrapper').fadeOut();
   } catch (error) {
     console.error(`${error}\r\n${error.statusText}\r\n${error.responseText}`);
   }
 }

 function updateList() {
   var bounds = map.getBounds();
   var count = 0;

   //debug
   console.log('updateList()');
   console.log(bounds);

   if (bounds !== undefined) {
     jQuery('.loading-wrapper').show();
     jQuery('#listResults').html('');

     markers.forEach(marker => {
       if (bounds.contains(marker.getPosition())) {
         jQuery('#listResults').append(marker.markup);
         count++;
       }
     });

     jQuery('#resultsCount').html(count);
     jQuery('.loading-wrapper').fadeOut();
   }
 }

 function highlightMarker(marker_id) {
   markers.forEach(marker => {
     if (marker.customID === marker_id) {
       google.maps.event.trigger(marker, 'click');
     }
   });
 }

 function initAutocomplete() {
   var autocomplete = new google.maps.places.Autocomplete(document.getElementById('searchLocation'), {
     componentRestrictions: { country: 'au' }
   });

   //debug
   console.log('initAutocomplete()');

   autocomplete.addListener('place_changed', function () {
     var place = autocomplete.getPlace();
     if (!place.geometry) {
       window.alert("Autocomplete's returned place contains no geometry");
       return;
     }
     map.panTo(place.geometry.location);
     fetchLocations(map.getCenter().lat(), map.getCenter().lng(), map.getZoom());
   });
 }

 function getUrlParameter(name) {
   name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
   var regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
   var results = regex.exec(location.search);
   return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
 }

 jQuery(document).on('click', '.feedback-link', function () {
   var locationTitle = jQuery(this).data('title');
   var locationAddress = jQuery(this).data('address');
   jQuery('.modal-body #input_11_3').val(locationTitle); // hidden title field

   jQuery('.modal-body #input_11_5').val(locationAddress); // hidden title field
   // As pointed out in comments,
   // jQuery("#addBookDialog").modal("show");
 });

// Load the Map
jQuery(document).ready(function() {
	/*
	Reset Modal on close
	*/
	jQuery("#feedbackModal").on("hidden.bs.modal", function() {
	$this = jQuery(this);
	$this.find('form')[0].reset();
	$this.find('.val_summary').remove(); // the validation summary message
	$this.find('input[type=text]').val('');
	$this.find('li.gfield_error div.validation_message').remove(); // remove the validation meesages
	$this.find('li.gfield_error').removeClass('gfield_error'); // remove the validation classes.
	});

	// Check GeoLocation - otherwise default to Melbourne
	preInitMap();

	// console.log(map_center);
	// getLocationData('GetMerchantBrandList', '#selectSiteName');
	// getFuelData('GetFuelTypeList', '#selectFuelType');
	// initMap();
});
